import { useEffect, useState } from 'react'

/**
 * Parameters of the URL fragment. Emailed links carry their secrets after the `#`, so they never reach a server in
 * a GET, a log or a Referer header (R23). They are read once, kept in memory, and removed from the address bar.
 */
export function useHashParams(): URLSearchParams {
  const [params] = useState(() => new URLSearchParams(window.location.hash.replace(/^#/, '')))
  useEffect(() => {
    if (window.location.hash) {
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search)
    }
  }, [])
  return params
}
